export function createRegExp(input) {
    input = input.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '\\$&');
    return new RegExp(input, 'g');
}